import React from 'react'
import { Box, Flex } from 'grid-styled'
import Hide from 'styles/utilities/Hide'
import { withRouter } from 'react-router-dom'

import DropdownList, { ListItem as DropListItem } from 'app/modules/IdentifiersList/DropdownList'
import DotButton from 'app/elements/DotButton'
// import Checkbox from 'app/elements/Checkbox'
import Icon from 'app/elements/Icon/Icon'

import Tooltip from 'app/elements/TextInput/Tooltip'
import ToggleSwitch from 'app/elements/ToggleSwitch'

import PlusIcon from 'app/elements/Icon/ic-plus'
import { ChipContainer, Chip, ChipEmpty, ListItem, LineTextContainer, LineText } from './styles'

import { gqlMutate } from '../../../alelo-logic/services/common/apolloClient'
import { gqlModificarPapIndividual } from '../../../alelo-logic/services/queries/vehicles'

const IdentifierListItem = ({
  checkboxValues,
  vehicle,
  itemDropdownId,
  history,
  isItemDropdownOpen,
  handleSelectItem,
  handleItemDropdown,
  handleItemDropdownClose,
  handleCreateInf,
  itemStatus,
  isPartner,
  changeTagIdentifiers,
  idConta
}) => {
  const { idIdentificador, veiculo, situacao, codIdentificador, informacoesGerenciais } = vehicle
  const active = situacao === 'ATIVO'
  const carPlate = veiculo.placa
  const identifierId = codIdentificador
  const carCategory = veiculo.categoria
  const carType = veiculo.tipo === 'CAMINHAO' ? 'Caminhão' : veiculo.tipo
  const sortedInfos = sortedInformations(informacoesGerenciais)
  // const isChecked = !!checkboxValues.find(item => item.idIdentificador === idIdentificador)
  const renderIndexInfoManage = tipo =>
    tipo === 'INFORMACAO_1' ? 1 : tipo === 'INFORMACAO_2' ? 2 : 3
  let loadingPap = false
  function onUnload() {
    loadingPap = true
  }

  window.addEventListener('beforeunload', onUnload)

  function sortedInformations(informations) {
    return informations == null
      ? null
      : informations.sort((a, b) => {
          return a.tipoInfo.toLowerCase() < b.tipoInfo.toLowerCase() ? -1 : 1
        })
  }

  function getWarnTags(identifierId) {
    const listTagsWarn = JSON.parse(sessionStorage.getItem('warnTags'))
    if (listTagsWarn && listTagsWarn.tags && listTagsWarn.tags.includes(parseInt(identifierId)))
      return listTagsWarn.tags
    return false
  }

  const togglePap = async checked => {
    vehicle.pap = checked ? 1 : 0
    changeTagIdentifiers(vehicle)

    try {
      await gqlMutate(gqlModificarPapIndividual, {
        idConta: idConta,
        adesaoPap: checked,
        identificador: vehicle.codIdentificador,
        placa: veiculo.placa
      })
      changeTagIdentifiers(vehicle)
    } catch (error) {
      vehicle.pap = !checked ? 1 : 0
      changeTagIdentifiers(vehicle)
      if (!loadingPap) {
        alert('Problema ao executar pap')
      } else {
        loadingPap = false
        window.removeEventListener('beforeunload', this.onUnload)
      }
    }
  }

  return (
    <ListItem blocked={!!active} warn={!getWarnTags(identifierId)}>
      <Flex width={1} direction={['column', 'row']}>
        {/* <Box width={[1 / 12, 0.5 / 12]}>
          <LineTextContainer>
            <Checkbox checked={isChecked} onChange={handleSelectItem(vehicle)} />
          </LineTextContainer>
        </Box> */}
        <Box width={[3 / 12, 2 / 12]}>
          <LineTextContainer>
            {getWarnTags(identifierId) && (
              <Tooltip text="Esta tag precisa ser trocada." tooltipColor="#e5b200" showTooltip>
                <Icon
                  style={{ marginRight: '5px' }}
                  height={14}
                  icon="alertTag"
                  viewBox="0 0 16 16"
                  display="flex"
                />
              </Tooltip>
            )}
            <LineText capitalize bold>
              {carType.toLowerCase()}
            </LineText>
          </LineTextContainer>
        </Box>
        <Box width={[3 / 12, 2 / 12]}>
          <LineTextContainer>
            <LineText>{carPlate}</LineText>
          </LineTextContainer>
        </Box>
        <Hide at="small" width={[1, 2 / 12]}>
          <LineTextContainer>
            <LineText>{carCategory}</LineText>
          </LineTextContainer>
        </Hide>
        <Box width={[3 / 12, 2 / 12]}>
          <LineTextContainer>
            <LineText>{identifierId}</LineText>
          </LineTextContainer>
        </Box>
        <Box width={[3 / 12, 3 / 12]}>
          <ChipContainer>
            {!sortedInfos || sortedInfos.length === 0 ? (
              <ChipEmpty onClick={() => handleCreateInf(vehicle)}>
                <PlusIcon /> Add Informação
              </ChipEmpty>
            ) : (
              sortedInfos.map((item, i) => (
                <Chip key={i}>
                  {renderIndexInfoManage(item.tipoInfo)}. {item.descricaoAtual}
                </Chip>
              ))
            )}
          </ChipContainer>
        </Box>
        {isPartner && (
          <Box width={[3 / 12, 2 / 12]} style={{ paddingTop: '15px' }}>
            <ToggleSwitch
              checked={vehicle.pap === 1}
              label={vehicle.pap === 1 ? 'Ativo' : 'Inativo'}
              name="pap"
              togglePap={togglePap}
            />
          </Box>
        )}
        <Box width={[1, 0.5 / 12]}>
          <LineTextContainer>
            <DotButton onClick={handleItemDropdown(idIdentificador)} />
            <DropdownList
              secondary
              isOpen={isItemDropdownOpen && itemDropdownId === idIdentificador}
              onClose={handleItemDropdown()}
            >
              {itemStatus !== 'INATIVO' &&
                !isPartner && (
                  <DropListItem
                    onClick={() => history.push(`identificador/${identifierId}/bloquear`)}
                  >
                    Bloquear / Substituir
                  </DropListItem>
                )}
              <DropListItem onClick={() => history.push(`identificador/${identifierId}/alterar`)}>
                Gerenciar informações
              </DropListItem>
            </DropdownList>
          </LineTextContainer>
        </Box>
      </Flex>
    </ListItem>
  )
}

IdentifierListItem.defaultProps = {
  checkboxValues: [],
  vehicle: {},
  handleSelectItem: () => {},
  itemDropdownId: 0,
  isItemDropdownOpen: false,
  handleItemDropdown: () => {},
  handleItemDropdownClose: () => {},
  handleCreateInf: () => {}
}

export default withRouter(IdentifierListItem)



// WEBPACK FOOTER //
// ./src/app/elements/IdentifiersListItem/index.js